import PerfectScrollbar from 'perfect-scrollbar';

$(window).on('resize',function() {
  	if($('.js-gallery-scroll-gal1').height() > 0) {
		var ps = new PerfectScrollbar('.js-gallery-scroll-gal1', {
			wheelSpeed: 0.8,
			wheelPropagation: true,
			minScrollbarLength:180,
			maxScrollbarLength:180,
			suppressScrollY: true,
			useBothWheelAxes: true
		});
	}

	if($('.js-gallery-scroll-new-gallery').height() > 0) {
		var psq = new PerfectScrollbar('.js-gallery-scroll-new-gallery', {
			wheelSpeed: 0.8,
			wheelPropagation: true,
			minScrollbarLength:180,
			maxScrollbarLength:180,
			suppressScrollY: true,
			useBothWheelAxes: true
		});
	}

	if($('.js-gallery-scroll').height() > 0) {
		var psw = new PerfectScrollbar('.js-gallery-scroll', {
			wheelSpeed: 0.8,
			wheelPropagation: true,
			minScrollbarLength:180,
			maxScrollbarLength:180,
			suppressScrollY: true,
			useBothWheelAxes: true
		});
	}

	if($('.js-gallery-scroll-new').height() > 0) {
		var pse = new PerfectScrollbar('.js-gallery-scroll-new', {
			wheelSpeed: 0.8,
			wheelPropagation: true,
			minScrollbarLength:180,
			maxScrollbarLength:180,
			suppressScrollY: true,
			useBothWheelAxes: true
		});
	}
});

$(document).ready(function() {
    $(window).trigger('resize');
});

$('.js-gallery-scroll-promo').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4.5,
  arrows: true,
  nextArrow: '<button class="additional-arr additional-next-gallery"></button>',
  prevArrow: '<button class="additional-arr additional-prev-gallery"></button>',
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3.5,
      }
    },{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
      }
    }, 
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 2.3,
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1.2,
      }
    },
  ]
})


// WEBPACK FOOTER //
// ./src/js/pages/promo/gallery-scroll.js